import { render } from "./App.vue?vue&type=template&id=553bb79c"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__